import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import seo from "../config/seo.json";

function setMeta(attribute, key, content) {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  document.head.querySelectorAll(selector).forEach((duplicate) => {
    if (duplicate !== element) duplicate.remove();
  });
  element.setAttribute("content", content);
}

function setCanonical(url) {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  document.head.querySelectorAll('link[rel="canonical"]').forEach((duplicate) => {
    if (duplicate !== element) duplicate.remove();
  });
  element.setAttribute("href", url);
}

export default function SEOHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = seo.pages.find(({ path }) =>
      matchPath({ path, end: true }, pathname)
    );
    const title = page?.title || "Social Media Workspace Page - Socialyorix";
    const description =
      page?.description ||
      "Manage social media content, publishing plans and business workflows in the Socialyorix marketing workspace.";
    const canonical = `${window.location.origin}${pathname}`;
    const image = `${window.location.origin}${seo.image}`;

    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "author", seo.author);
    setMeta("name", "keywords", (page?.keywords || []).join(", "));
    setMeta("name", "robots", "noindex, nofollow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:site_name", seo.siteName);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:url", canonical);
    setMeta("name", "twitter:image", image);
    setCanonical(canonical);
  }, [pathname]);

  return null;
}